import React, { useEffect, useState } from 'react';
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { formatDate } from "../../utils/formatDate";
import Loader from '../loader/Loader';

const SuperCorrectiveActionReportView = ({ show, handleClose, ncReportId }) => {

  const [correctivreport, setCorrectivreport] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCorrectivreportList = async () => {
    const token = getAuthToken();
    if (!token || !ncReportId) return;

    setLoading(true);
    try {
      const res = await axios.get(
        `${config.API}/supervisor/viewcorrectiveactionreport/${ncReportId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res?.data?.success) {
        setCorrectivreport(res.data?.nc_report);
        console.log(res?.data?.nc_report)
      }
    } catch (err) {
      toast.error("Failed to load NC report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && ncReportId) {
      fetchCorrectivreportList();
    }
  }, [show, ncReportId]);

  if (!correctivreport) return null;

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
     {
      loading ? (
        <Loader/>
      ) :(
         <Modal.Body className='p-5'>

        <strong className='fs-4'>Corrective Action Report</strong>

        {/* NC Information */}
        <div className="p-3 mb-4 bg-light mt-4">
          <Row>
            <Col><strong>Product Name:</strong> {correctivreport?.product?.name}</Col>
            <Col><strong>Product ID:</strong> {correctivreport?.product?.product_code}</Col>
          </Row>

          <Row className="mt-2">
            <Col><strong>Qty NC:</strong> {correctivreport?.nc_count}</Col>
            <Col><strong>Report Date:</strong> {formatDate(correctivreport?.created_at)}</Col>
          </Row>

          <Row className="mt-2">
            <Col><strong>Reported by:</strong> {correctivreport?.user?.name}</Col>
            <Col><strong>NC Type:</strong> {correctivreport?.reason}</Col>
          </Row>

          <Row className="mt-3">
            <Col></Col>
            <Col>
              <Button variant="" className='btn bg-white'>Review NC Report</Button>
            </Col>
          </Row>
        </div>

        {/* Inspection Checklist */}
        <div className="p-3 mb-4 bg-light">
          <strong>Inspection Checklist</strong>

          <Form.Group>
            <Form.Check
              label="Visual Inspection (No visible defects)"
              checked={correctivreport?.visual_inspection}
            />

            <Form.Check
              label="Dimensional Check (Meets specifications)"
              checked={correctivreport?.dimensional_check}
            />

            <Form.Check
              label="Quantity Check (Matches delivery note)"
              checked={correctivreport?.quantity_check}
            />

            <Form.Check
              label="Packaging Condition (No damage)"
              checked={correctivreport?.packaging_condition}
            />

            <Form.Check
              label="Material Certificate (Provided and valid)"
              checked={correctivreport?.material_certificate}
            />
          </Form.Group>
        </div>

        {/* Inspection Results */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label><strong>Producted Inspected</strong></Form.Label>
          </Col>
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="number"
                value={correctivreport?.nc_inspected ?? 0}
                readOnly
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <Form.Label><strong>Producted Passed</strong></Form.Label>
          </Col>
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="number"
                value={correctivreport?.nc_passed ?? 0}
                readOnly
              />
            </div>
          </Col>
        </Row>

        {/* Notes */}
        <Row className='mt-5'>
          <Col md={1}></Col>
          <Col md={2}>
            <Form.Label><strong>Notes</strong></Form.Label>
          </Col>
          <Col md={9}>
            <Form.Control
              as="textarea"
              rows={3}
              value={correctivreport?.correction_description || ""}
              readOnly
            />
          </Col>
        </Row>

      </Modal.Body>
      )
     }

      <Modal.Footer className='border-0'>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuperCorrectiveActionReportView;